<template>
  <div class="chooes-input">
    <div class="title"></div>
    <div class="choose">
      <div class="leftis">{{placeholder}}</div>
      <div class="rightis">
        <div class="choose-center"><slot></slot></div>
        <img src="@/assets/image/choose.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {}
  },
  data() {
    return {
      focused: false,
      showFlag: false
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.chooes-input{
  height: 56px;
  padding: 0 20px;
  .choose {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-radius: 10px;
    padding:0 8px;
    height: 40px;
    background-color: #f2f2f7;
    .leftis {
      width: 40%;
    }
    .rightis {
      width: 40%;
      font-size: 12px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 80%;
      .choose-center {
        margin-right: 8px;
      }
    }
  }
  .title {
    font-size: 12px;
    color: #908ee4;
    height: 16px;
    line-height: 16px;
    visibility: hidden;
    &.show{
      visibility: visible;
    }
  }
}
</style>